export default "__VITE_ASSET__0e584087__"